import * as React from 'react';
import {EnvironmentEnum, isInEnvironment} from '@/environment/service/host';

const shouldEnableDevelopmentTools =
  isInEnvironment(EnvironmentEnum.Local) || isInEnvironment(EnvironmentEnum.Staging);

const DevelopmentTools = React.lazy(async () =>
  shouldEnableDevelopmentTools
    ? import('@/features/development/components/DevelopmentTools').then((d) => ({
        default: d.DevelopmentTools,
      }))
    : Promise.resolve({default: () => null}),
);

const DevelopmentToggles = React.lazy(async () =>
  shouldEnableDevelopmentTools
    ? import('@/features/development/components/DevToggles').then((d) => ({
        default: d.DevtoolToggles,
      }))
    : Promise.resolve({default: () => null}),
);

export {DevelopmentToggles, DevelopmentTools, shouldEnableDevelopmentTools};
